import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { RemoteAction } from '../../remote-action';
import { LocationService } from 'src/app/_services/location/location.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { IMSObject } from 'src/app/_model/ims-object';
import { BranchesService } from 'src/app/_services/branches/logic/branches.service';
import { ServicejobsService } from 'src/app/_services/servicejobs/logic/servicejobs.service';
import { Servicejob } from 'src/app/_model/servicejob';
import { Branch } from 'src/app/_model/branches';

@Injectable()
export class UpdatePositionRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    obj: IMSObject,
    lat: number,
    long: number,
    branchesService: BranchesService,
    servicejobsService: ServicejobsService,
    appService: AppService,
    private appParameterService: AppParameterService,
    credentialsService: CredentialsService,
    locationService: LocationService,
    private logger?: LoggingService
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'updateposition',
        data: {
          objid: obj.id.imsId,
          secondaryobjid: obj.id.secondaryId,
          objref: obj.id.objRef,
          lat: lat,
          long: long,
        },
        cachable: true,
        fifo: false,
        authenticationRequired: true,
        shortLabel: 'UPDATE-POSITION-REMOTEACTION.RA.LABEL.SHORT',
        shortLabelTranslate: true,
        longLabel: obj?.displayLabel,
        longLabelTranslate: false,
      },
      [new GpsRemoteActionBuilderServiceStep(locationService, logger)],
      async () => {
        logger.log(this.constructor.name, ' Executing post generate function');

        if (obj?.id.objRef === 'ims/ServiceJob') {
          const sjob = obj as Servicejob;
          sjob.validlatitude = lat;
          sjob.validlongitude = long;
          sjob.geodataisaddresspreciseormanual = true;
          sjob.geodataismanual = true;
          await servicejobsService.updateServicejob(sjob);
        } else if (obj?.id.objRef === 'ims/Branch') {
          const branch = obj as Branch;
          branch.validlatitude = lat;
          branch.validlongitude = long;
          branch.geodataisaddresspreciseormanual = true;
          branch.geodataismanual = true;
          await branchesService.updateBranch(branch);
        }
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    return super.generateRemoteAction(dataValues);
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);
    return componentRef;
  }
}
